/**
 *
 * LoginePage
 *
 */
import { memo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Topbar } from '../Components/Topbar';
import { ImageHeader } from '../Components/ImageHeader';
import { CustomButtonValidate } from 'app/components/CustomButtonValidate';
import ReCAPTCHA from 'react-google-recaptcha';
import Pub from './assets/img/groupe-785.jpg';
import { CustomInputText } from 'app/components/CustomInputText';
import { Form } from 'antd';
import history from 'utils/history';
import { useCheckLoginMutation } from 'app/services/api/AuthApi';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

import './assets/css/styles.css';
import { getErrorMessage } from 'utils/error';
import { ErrorMessage } from 'app/components/ErrorMessage/Loadable';

interface Props {}

export const LoginePage = memo((props: Props) => {
  const [checkLogin, result] = useCheckLoginMutation();
  const [isValid, setIsValid] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const onFinish = values => {
    checkLogin(values.login)
      .unwrap()
      .then(result => {
        history.push('/simple-auth', {
          login: result.login,
          doubleAuth: result.doubleAthe,
        });
        localStorage.setItem('role', result?.roles[0]?.name);
      })
      .catch(error => setError(getErrorMessage(error)));
  };

  const onCaptchaChange = value => {
    setIsValid(value!!);
  };

  return (
    <Container fluid>
      <Topbar />
      <Row className="login-bottom-width" />
      <ImageHeader />
      <Row style={{ margin: '20px 5% 0 5%' }}>
        <Col md={6}>
          <p className="txt-title">
            Veuillez vous connecter <br /> pour continuer
          </p>
          <Form layout="vertical" onFinish={onFinish} autoComplete="on">
            <CustomInputText
              type="text"
              nameInput="login"
              label="Entrer votre login"
              required={true}
              errorMessage="Champ obligatoire"
              placeholder="Entrer votre login ou numéro de téléphone"
            />
            <div className="d-flex justify-content-center mb-4 align-items-center ">
              <ReCAPTCHA
                style={{ display: 'inline-block' }}
                sitekey={process.env.REACT_APP_CAPTACHA_SITE_KEY}
                onChange={onCaptchaChange}
                type="image"
              />
            </div>
            <div className="d-flex justify-content-center mb-4 align-items-center ">
              <LoadingIndicator loading={result.isLoading} />
            </div>
            <div className="d-flex justify-content-center mb-4 align-items-center ">
              <ErrorMessage error={error} />
            </div>
            <div>
              <CustomButtonValidate className="w-100" text="Suivant" isValid={isValid && !result.isLoading} />
            </div>
          </Form>
        </Col>
        <Col md={6}>
          <div className="d-flex align-items-center">
            <img src={Pub} alt="PubImage" className="w-100" />
          </div>
        </Col>
      </Row>
    </Container>
  );
});
